/**
 * Created by Owlz on 23/10/2017.
 */

const levelData = {
    level_1: {
        map: [
            [0, 0, 6, 7, 2],
            [0, 0, 0, 0, 0],
            [3, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 3, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 3],
            [3, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [3, 0, 0, 0, 3],
            [0, 3, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [3, 0, 0, 0, 0],
            [0, 0, 3, 0, 0],
            [0, 0, 0, 3, 0],
            [3, 0, 0, 0, 3],
            [3, 0, 3, 3, 3]
        ],
        edgeL: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [1, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [3, 0, 0],
            [1, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [1, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
        ],
        edgeR: [
            [2, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [1, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [3, 0, 0],
            [1, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [1, 2, 2],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
        ]
    }
};

export default levelData;